module.exports = __webpack_public_path__ + "img/account--icon.6529ab42.svg";